<ng-container *ngIf="sortedEntries as entries">
  <ng-content></ng-content>
  <div *ngFor="let entry of entries; let i = index"
       [ngClass]="{
         'mb-6': entries.length > 1 && isNeedToShowProvider(getNextEntryIndex(i),entries[getNextEntryIndex(i)]),
         'mb-5': i!==entries.length - 1  && entries.length > 1 && !isNeedToShowProvider(getNextEntryIndex(i),entries[getNextEntryIndex(i)]),
         'mb-6 mb-lg-7': i===entries.length - 1
       }"
       [class.tile-disabled]="entry.removed === 'removing'"
  >
    <div *ngIf="isNeedToShowProvider(i, entry)">
      <ng-container *ngIf="getProductVendor(entry)">
        <h2 class="ds-heading--xxs ds-font--medium mb-3 mt-4">
          {{'checkoutOrderConfirmation.providedBy' | cxTranslate}}
          <dcp-provided-by-tooltip
            [vendorAddress]="getProductVendorAddress(entry)"
          ></dcp-provided-by-tooltip>
        </h2>
      </ng-container>
    </div>
    <ng-container
      *ngTemplateOutlet="providedOrderEntriesTmpl,
      context: { $implicit: {entry: entry, entryCount: entryCount}}"
    ></ng-container>
  </div>
</ng-container>
